
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Input, Button, Alert, Spin, Card } from "antd";
import { MailOutlined } from "@ant-design/icons";
import axios from "axios";
import "./forgotPassword.css";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || ""); // Prefill from login page
  const [firstName, setFirstName] = useState("User");
  const [emailError, setEmailError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resetLink, setResetLink] = useState(""); // ✅ Store real reset link

  const emailRegex = /^[^\s@]+@ust\.com$/;

  // ✅ Fetch user data safely
  useEffect(() => {
    if (email && emailRegex.test(email)) {
      axios.get(`http://localhost:8080/api/user/${email}`)
        .then((response) => {
          console.log("User API Response:", response.data); // ✅ Debugging log
          setFirstName(response.data.firstName || "User");
        })
        .catch((error) => {
          console.error("User API Error:", error.response ? error.response.data : error.message);
          setFirstName("User");
        });
    }
  }, [email]);

  const handleSubmit = async () => {
    setEmailError(null);
    setSuccessMessage(null);
    setResetLink(null);
    setLoading(true);

    if (!email.trim()) {
      setEmailError("Email is required.");
      setLoading(false);
      return;
    }

    if (!emailRegex.test(email)) {
      setEmailError("Enter a valid email address ending with @ust.com.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        "http://localhost:8080/api/forgot-password",
        { email },
        { headers: { "Content-Type": "application/json" } } // ✅ Ensure correct format
      );

      const resetLinkFromAPI = response.data.resetLink; // ✅ Extract reset link
      setResetLink(resetLinkFromAPI);

      setSuccessMessage("A password reset link has been generated. Click below to reset your password.");
    } catch (error) {
      console.error("Error:", error);
      setEmailError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <Card className="forgot-password-card">
        <h2 className="title">Forgot Password?</h2>
        <p className="subtitle">Hi {firstName}, Enter your email id to receive a password reset link.</p>

        {successMessage && (
          <Alert
            message={
              <div>
                {successMessage}
                {resetLink && (
                  <p>
                    <a href={`${resetLink}`} target="_blank" rel="noopener noreferrer">
                      Click here to reset your password
                    </a>
                  </p>
                )}
              </div>
            }
            type="success"
            showIcon
          />
        )}

        {emailError && <Alert message={emailError} type="error" showIcon />}

        <Input
          className="email-input"
          size="large"
          placeholder="Enter your email"
          prefix={<MailOutlined />}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <Button className="submit-button" type="primary" onClick={handleSubmit} loading={loading}>
          Reset Password
        </Button>
      </Card>
    </div>
  );
};

export default ForgotPassword;
